import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';

import { BlurEvent, CKEditorModule } from '@ckeditor/ckeditor5-angular';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorConfig } from '@ckeditor/ckeditor5-core';

@Component({
  selector: 'apm-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CKEditorModule, ReactiveFormsModule],
})
export class EditorComponent {
  initialValue = input('');
  form = input.required<AbstractControl>();

  focusLost = output<BlurEvent>();

  Editor = ClassicEditor;
  defaultConfig: EditorConfig = {
    toolbar: {
      items: ['heading', '|', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo'],
    },
    language: 'en',
  };

  onBlur(event: BlurEvent) {
    this.focusLost.emit(event);
  }
}
